import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { CONFIG_URLS_API } from 'src/environments/config-envs';
import { LocalStorageService } from './localstorage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GerenciarCotaService {
  private readonly httpOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  //urlSlot01 = 'https://homolog.portalctf.com.br/ctf-services/';

  // BehaviorSubject para armazenar o TipoContrato
  private tipoContratoSubject = new BehaviorSubject<number | null>(null);
  public tipoContrato$ = this.tipoContratoSubject.asObservable();

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
  ) {}

  // Método para atualizar o TipoContrato
  setTipoContrato(tipoContrato: number): void {
    if (this.tipoContratoSubject.value === null) {
      this.tipoContratoSubject.next(tipoContrato);
    }
  }

  // Método para obter o TipoContrato atual
  getTipoContrato(): number | null {
    return this.tipoContratoSubject.value;
  }

  getDadosMacro(
    codFrota: number,
    userGuid: string,
    cmdName?: string,
  ): Observable<{
    sucesso: boolean;
    retorno: any[];
    mensagens: any;
    mostraValSaldo?: boolean;
    mostraValAjuste?: boolean;
  }> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_Cotas+`/BuscaLimitesDadosMacro?guid=${userGuid}`;

    const body: any = {
      CodFrota: codFrota,
    };

    if (cmdName) {
      body.CmdName = Number(cmdName);
    }

    return this.http.post<any>(url, body, this.httpOptions).pipe(
      map((response) => {
        // Capturar tipoContrato do primeiro item do array que tiver valor
        if (
          response.sucesso &&
          response.retorno &&
          response.retorno.length > 0
        ) {
          for (const item of response.retorno) {
            if (item.tipoContrato !== undefined && item.tipoContrato !== null) {
              this.setTipoContrato(item.tipoContrato);
              break;
            }
          }
        }
        return response;
      }),
    );
  }

  // BuscaLimitesMacro - Primeira API quando o usuário for MACRO (tipo=8)
  // Para obter as informações e características da Macro quando já se tem o CodMacro
  getBuscaLimitesMacro(
    codMacro: number,
    userGuid: string,
    cmdName?: string,
  ): Observable<{
    sucesso: boolean;
    retorno: any[];
    mensagens: any;
    mostraValSaldo?: boolean;
    mostraValAjuste?: boolean;
  }> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_Cotas+`/BuscaLimitesMacro?guid=${userGuid}`;

    const body: any = {
      CodMacro: codMacro,
    };

    if (cmdName) {
      body.CmdName = Number(cmdName);
    }

    return this.http.post<any>(url, body, this.httpOptions).pipe(
      map((response) => {
        // Capturar tipoContrato do primeiro item do array que tiver valor
        if (
          response.sucesso &&
          response.retorno &&
          response.retorno.length > 0
        ) {
          for (const item of response.retorno) {
            if (item.tipoContrato !== undefined && item.tipoContrato !== null) {
              this.setTipoContrato(item.tipoContrato);
              break;
            }
          }
        }
        return response;
      }),
    );
  }

  getBuscaLimitesFrota(
    codMacro: number,
    codFrota: number | null,
    codGrupoCombustivel: number,
    codTipoLimite: number,
    userGuid: string,
    cmdName?: string,
  ): Observable<{ sucesso: boolean; retorno: any[] }> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_Cotas+`/BuscaLimitesFrota?guid=${userGuid}`;

    const tipoContrato = this.getTipoContrato();
    // Se o usuário for Macro (tipo=8), não passa CodFrota
    // Se o usuário for Frota (tipo!=8), passa CodMacro e CodFrota
    const body: any = {
      CodMacro: codMacro,
      CodGrupoCombustivel: codGrupoCombustivel,
      CodTipoLimite: codTipoLimite,
      TipoContrato: tipoContrato,
      CmdName: cmdName ? Number(cmdName) : undefined,
    };

    // Só adiciona CodFrota se foi passado (usuário tipo Frota)
    if (codFrota !== null) {
      body.CodFrota = codFrota;
    }

    return this.http.post<any>(url, body, this.httpOptions);
  }

  getBuscaLimitesSubFrota(
    codMacro: number,
    codFrota: number,
    codGrupoCombustivel: number,
    codTipoLimite: number,
    userGuid: string,
    cmdName?: string,
    indGetCota?: number,
  ): Observable<{
    sucesso: boolean;
    retorno: any[];
    indOcultarVeiculos?: boolean;
    editaValAjuste?: boolean;
    mostraBotaoAcao?: boolean;
  }> {
    let url = environment.host_ctf_service+ CONFIG_URLS_API.API_Cotas+`/BuscaLimitesSubFrota?guid=${userGuid}`;

    const tipoContrato = this.getTipoContrato();
    const body: any = {
      CodMacro: codMacro,
      CodFrota: codFrota,
      CodGrupoCombustivel: codGrupoCombustivel,
      CodTipoLimite: codTipoLimite,
      CmdName: Number(cmdName),
      TipoContrato: tipoContrato,
    };

    // Adicionar IndGetCota se foi passado
    if (indGetCota !== undefined) {
      body.IndGetCota = indGetCota;
    }

    return this.http.post<any>(url, body, this.httpOptions);
  }

  getBuscaLimitesVeiculo(
    codSubfrota: number,
    codGrupoCombustivel: number,
    codTipoLimite: number,
    userGuid: string,
    codFrota?: number,
    cmdName?: string,
  ): Observable<{
    sucesso: boolean;
    retorno: any[];
    editaValAjuste?: boolean;
  }> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_Cotas+`/BuscaLimitesVeiculo?guid=${userGuid}`;

    const tipoContrato = this.getTipoContrato();
    const body: any = {
      CodSubfrota: codSubfrota,
      CodGrupoCombustivel: codGrupoCombustivel,
      CodTipoLimite: codTipoLimite,
      TipoContrato: tipoContrato,
    };

    // Adicionar CodFrota se foi passado
    if (codFrota !== undefined) {
      body.CodFrota = codFrota;
    }

    // Adicionar CmdName se foi passado
    if (cmdName) {
      body.CmdName = Number(cmdName);
    }

    return this.http.post<any>(url, body, this.httpOptions);
  }

  // Método para salvar os ajustes usando ConsolidaAtualizacaoDeCotas
  saveAdjustments(
    payload: {
      DscObservacao: string;
      ListLimiteFrotaTO?: Array<{
        CodMacro?: number;
        CodFrota?: number;
        DscFrota?: string;
        IndGetCota?: number;
        IndGetSubFrotaCota?: number;
        IndSetSubFrotaCota?: number;
        CodTipoLimite?: number;
        CodGrupoCombustivel?: number;
        ValSaldo?: number;
        ValLimite?: number;
        ValAjusteSaldo?: number;
        UltimoAjuste?: Date;
        CodAcesso?: number;
        CodTipoEntidade?: number;
        CodEntidadeOrigem?: number;
        CodTipoEntidadeOrigem?: number;
        CodEntidadeDestino?: number;
        CodTipoEntidadeDestino?: number;
        NumProtocolo?: number;
        CodPeriodicidade?: number;
        CodVeiculo?: number;
        CryptSaldo?: string;
        CryptKeys?: string;
        TipoContrato?: number | null;
        tipoContrato?: number | null;
      }>;
      ListLimiteSubFrotaTO?: Array<{
        CodFrota?: number;
        CodSubFrota?: number;
        DscSubFrota?: string;
        ValSaldo?: number;
        ValLimite?: number;
        QtdVeiculos?: number;
        UltimoAjuste?: Date;
        CodGrupoCombustivel?: number;
        CodTipoLimite?: number;
        ValAjusteSaldo?: number;
        CodAcesso?: number;
        CodTipoEntidade?: number;
        CodEntidadeOrigem?: number;
        CodTipoEntidadeOrigem?: number;
        CodEntidadeDestino?: number;
        CodTipoEntidadeDestino?: number;
        NumProtocolo?: number;
        CodPeriodicidade?: number;
        CodVeiculo?: number;
        IndTipoConta?: string;
        DscPeriodicidade?: string;
        CryptSaldo?: string;
        CryptKeys?: string;
        TipoContrato?: number | null;
        tipoContrato?: number | null;
      }>;
      ListLimiteVeiculoTO?: Array<{
        CodVeiculo?: number;
        CodSubFrota?: number;
        CodFrotaVeiculo?: string;
        DscPlaca?: string;
        DscModelo?: string;
        ValLimite?: number;
        ValSaldo?: number;
        UltimoAjuste?: Date;
        IndAtivo?: number;
        Bloqueado?: boolean;
        CodPeriodicidade?: number;
        DscSituac?: string;
        CodGrupoCombustivel?: number;
        CodTipoLimite?: number;
        DscStatus?: string;
        ValAjusteSaldo?: number;
        CodAcesso?: number;
        CodTipoEntidade?: number;
        CodEntidadeOrigem?: number;
        CodTipoEntidadeOrigem?: number;
        CodEntidadeDestino?: number;
        CodTipoEntidadeDestino?: number;
        NumProtocolo?: number;
        CodUsuario?: string;
        DscObservacao?: string;
        DscPeriodicidade?: string;
        IndTipoConta?: string;
        CryptSaldo?: string;
        CryptKeys?: string;
        TipoContrato?: number | null;
        tipoContrato?: number | null;
      }>;
      ListLimitePeriodicaSubFrotaTO?: any[];
      ListLimitePeriodicaFrotaTO?: any[];
      ListLimitePeriodicaVeiculoTO?: any[];
      CmdName?: number;
    },
    userGuid: string,
  ): Observable<{ sucesso: boolean; retorno: any; mensagens: string[] }> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_Cotas+`/ConsolidaAtualizacaoDeCotas?guid=${userGuid}`;

    // Obter o TipoContrato do Subject
    const tipoContrato = this.getTipoContrato();

    // Adicionar TipoContrato em cada item dos arrays
    if (payload.ListLimiteFrotaTO) {
      payload.ListLimiteFrotaTO = payload.ListLimiteFrotaTO.map((item) => ({
        ...item,
        TipoContrato: tipoContrato,
      }));
    }

    if (payload.ListLimiteSubFrotaTO) {
      payload.ListLimiteSubFrotaTO = payload.ListLimiteSubFrotaTO.map(
        (item) => ({
          ...item,
          TipoContrato: tipoContrato,
        }),
      );
    }

    if (payload.ListLimiteVeiculoTO) {
      payload.ListLimiteVeiculoTO = payload.ListLimiteVeiculoTO.map((item) => ({
        ...item,
        TipoContrato: tipoContrato,
      }));
    }

    return this.http.post<any>(url, payload, this.httpOptions);
  }
}
